(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory5Service", ['$ihttp', function ($ihttp) {
        let service = {
            getTextileModelCategory5: function (parms) {
                return $ihttp.post({
                    method: 2685,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2687,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
